import React from "react";
import PropTypes from "prop-types";
import FileDialog from "components/FileDialog";

const ProyeccionPDFDialog = ({ open, onClose, pdfUrl }) => {
  return (
    <FileDialog
      open={open}
      onClose={() => {
        onClose();
        if (pdfUrl) {
          window.URL.revokeObjectURL(pdfUrl);
        }
      }}
      title="Proyección de Pagos"
      content={
        pdfUrl && (
          <embed
            src={pdfUrl}
            type="application/pdf"
            width="100%"
            height="600px"
            style={{ border: "none" }}
          />
        )
      }
    />
  );
};

ProyeccionPDFDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  pdfUrl: PropTypes.string,
};

export default ProyeccionPDFDialog;
